import create from 'zustand'

interface PartnerSettingsState {
	registrationCertificatesEnabled: boolean
	transferAgreementsEnabled: boolean
	softClaimEnabled: boolean
	setRegistrationCertificatesEnabled: (
		registrationCertificatesEnabled: boolean,
	) => void
	setTransferAgreementsEnabled: (transferAgreementsEnabled: boolean) => void
	setSoftClaimEnabled: (softClaimEnabled: boolean) => void
}

export const usePartnerSettingsStore = create<PartnerSettingsState>(
	(set, get) => ({
		registrationCertificatesEnabled: false,
		setRegistrationCertificatesEnabled: (
			registrationCertificatesEnabled: boolean,
		) => set({ registrationCertificatesEnabled }),
		transferAgreementsEnabled: true,
		setTransferAgreementsEnabled: (transferAgreementsEnabled: boolean) =>
			set({ transferAgreementsEnabled }),
		// Off until the partner's settings say otherwise: nothing on the server
		// enforces this, so showing the control when we do not know the answer
		// would let a partner change what is offered to a counterparty.
		softClaimEnabled: false,
		setSoftClaimEnabled: (softClaimEnabled: boolean) =>
			set({ softClaimEnabled }),
	}),
)
